import * as React from "react"

function Resi(props) {
    return (
        <svg
            id="prefix__Livello_1"
            xmlns="http://www.w3.org/2000/svg"
            x={0}
            y={0}
            viewBox="0 0 50 50"
            xmlSpace="preserve"
            {...props}
        >
            <path
                className="prefix__st0"
                d="M24.8 2.2L1.2 13.4V37l23.6 11.3L48.3 37V13.4zM9.4 17.5L33 6.3"
            />
            <path className="prefix__st1" d="M30.9 39l13.3-6.1" />
            <path className="prefix__st0" d="M24.8 24.7v23.6" />
            <path
                className="prefix__st1"
                d="M42.2 22.6v7.2M39.6 26.8l2.6-4.2 2.5 1.8M34 26.7v7.2M31.5 30.9l2.5-4.2 2.6 1.8"
            />
            <path className="prefix__st0" d="M9.4 17.5v6.2l6.2 3v-6.1L39.1 9.3" />
            <path
                className="prefix__st0"
                d="M15.9 20.4l8.9 4.3 23.5-11.3M1.2 13.4l8.4 4"
            />
        </svg>
    )
}

export default Resi
